import { render, staticRenderFns } from "./CharacteristicMaster.vue?vue&type=template&id=2d0a8886"
import script from "./CharacteristicMaster.vue?vue&type=script&lang=js"
export * from "./CharacteristicMaster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports